import { get } from 'app/utils/axios/kheti'
import {CropsWithCategory, SowingRecord} from "../models/crop";

const fetchAllCrops = async () => {
  try {
    const url = "/crop/v2/all";
    const response = await get<CropsWithCategory[]>(url);
    return Object.entries(response)
        .filter(([key]) => key !== "api-trace-id")
        .map(([, value]) => value) as CropsWithCategory[];
  } catch (e) {
    return null;
  }
};

export default fetchAllCrops;
